import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { Observable } from 'rxjs';
import { ICostTypeCostCenterDistribution } from '../models/cost-type-cost-center-distribution.model';
import { ICostType } from '../models/cost-type.model';
import { CostAccountingRequestService } from '../services/cost-accounting-request.request.service';

const BASE_URL: string = 'cost-type';

@Injectable({
    providedIn: 'root',
})
export class CostTypeResource {
    constructor(private myCostAccountingRequestService: CostAccountingRequestService) {
    }

    public getCostTypes(onlyOrphaned: boolean, onlySecondary: boolean, onlyPrimary: boolean): Observable<ICostType[]> {
        const params: Params = { onlyOrphaned, onlySecondary, onlyPrimary };
        return this.myCostAccountingRequestService.get(BASE_URL, { params });
    }

    public createCostType(costType: ICostType): Observable<ICostType> {
        return this.myCostAccountingRequestService.post(BASE_URL, costType);
    }

    public updateCostType(costType: ICostType): Observable<ICostType> {
        return this.myCostAccountingRequestService.put(`${BASE_URL}/${costType.id}`, costType);
    }

    public deleteCostType(costTypeId: number): Observable<void> {
        return this.myCostAccountingRequestService.delete(`${BASE_URL}/${costTypeId}`);
    }

    public changeDistributionReference(costType: ICostType, referenceId: number): Observable<ICostType> {
        return this.myCostAccountingRequestService.patch(`${BASE_URL}/${costType.id}/reference`, { referenceId });
    }

    public getCostTypeDistributions(costType: ICostType): Observable<ICostTypeCostCenterDistribution[]> {
        return this.myCostAccountingRequestService.get(`${BASE_URL}/${costType.id}/cost-centers`);
    }

    public addCostTypeDistribution(distribution: ICostTypeCostCenterDistribution): Observable<ICostTypeCostCenterDistribution> {
        return this.myCostAccountingRequestService.post(`${BASE_URL}/${distribution.costTypeId}/cost-centers/${distribution.costCenterId}`, distribution);
    }

    public updateCostTypeDistribution(distribution: ICostTypeCostCenterDistribution): Observable<ICostTypeCostCenterDistribution> {
        return this.myCostAccountingRequestService.put(`${BASE_URL}/${distribution.costTypeId}/cost-centers/${distribution.costCenterId}`, distribution);
    }

    public deleteCostTypeDistribution(distribution: ICostTypeCostCenterDistribution): Observable<ICostTypeCostCenterDistribution> {
        return this.myCostAccountingRequestService.delete(`${BASE_URL}/${distribution.costTypeId}/cost-centers/${distribution.costCenterId}`);
    }

}
